<template>
  <button
    type="button"
    class="toggle"
    role="switch"
    :aria-checked="modelValue"
    :class="{ on: modelValue, sm: size === 'sm' }"
    :disabled="disabled"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span class="knob" />
  </button>
</template>

<script setup lang="ts">
defineProps<{ modelValue: boolean; disabled?: boolean; size?: 'sm' | 'md' }>()
defineEmits<{ (e: 'update:modelValue', v: boolean): void }>()
</script>

<style scoped>
.toggle {
  --w: 40px; --h: 22px; --pad: 2px;
  position: relative;
  width: var(--w); height: var(--h);
  flex: 0 0 auto;
  border-radius: var(--radius-full);
  border: none;
  background: var(--border-strong);
  cursor: pointer;
  padding: 0;
  transition: background var(--duration-base, 0.18s);
}
.toggle.sm { --w: 32px; --h: 18px; }
.toggle.on { background: var(--primary); }
.toggle:disabled { opacity: 0.5; cursor: not-allowed; }
.toggle:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }
.knob {
  position: absolute;
  top: var(--pad); left: var(--pad);
  width: calc(var(--h) - var(--pad) * 2);
  height: calc(var(--h) - var(--pad) * 2);
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: transform var(--duration-base, 0.18s) cubic-bezier(0.4, 0, 0.2, 1);
}
.toggle.on .knob { transform: translateX(calc(var(--w) - var(--h))); }
</style>
